import { render, staticRenderFns } from "./formReadGroupLabelInput.vue?vue&type=template&id=083c5fbc&"
import script from "./formReadGroupLabelInput.vue?vue&type=script&lang=js&"
export * from "./formReadGroupLabelInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports